<template>
  <div class="mt-0">
      <a href="#" class="tab__link p-3 block no-underline text-gray-800 flex content-center items-center border border-gray-400" @click.prevent="active = !active">
          <img v-if="image" :src="image" class="w-10">
          <div class="flex-1 font-bold px-3 text-lg">{{title}}</div>
          <span class="down-Arrow px-3 print:hidden" v-show="!active"><i aria-hidden="true" class="material-icons">visibility_off</i> <i aria-hidden="true" class="material-icons">expand_more</i></span>
          <span class="up-Arrow px-3 text-block text-red-800" v-show="active"><i aria-hidden="true" class="material-icons text-gray-300">visibility_off</i> <i aria-hidden="true" class="material-icons">cancel</i></span>
      </a>
    <div class="relative p-2" v-show="active"><slot /></div>            
  </div>
</template>

<script>
export default {

  props: ['title', 'color', 'description', 'image'],

  data () {
  return {
      active: false,
    }
  },
}
</script>
